"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (_a) {
    var xhr = _a.xhr, progress = _a.progress, resolve = _a.resolve;
    xhr.upload.addEventListener('progress', function (event) {
        if (!progress)
            return false;
        progress(Math.round((event.loaded / event.total) * 100));
    });
    xhr.addEventListener('load', function () {
        var response;
        try {
            response = JSON.parse(xhr.response);
        }
        catch (e) {
            response = xhr.response;
        }
        var headers = xhr
            .getAllResponseHeaders()
            .trim()
            .split(/[\r\n]+/)
            .map(function (line) { return line.split(': '); })
            .reduce(function (acc, _a) {
            var _b = __read(_a, 2), header = _b[0], value = _b[1];
            acc[header] = value;
            return acc;
        }, {});
        resolve({
            response: response,
            error: xhr.status < 200 || xhr.status >= 300,
            status: xhr.status,
            headers: headers,
        });
    });
    xhr.addEventListener('error', function (error) {
        resolve({ error: error, status: xhr.status, response: xhr.response });
    });
    xhr.addEventListener('abort', function (aborted) {
        resolve({ aborted: aborted });
    });
});
//# sourceMappingURL=register-listeners.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/libs/navjobs-upload/request/register-listeners.js
// module id = 2560
// module chunks = 0